import { FC } from 'react';

const TestClientPill: FC = () => (
  <div className="rounded-full bg-orange-25 py-1.5 px-4 text-center text-small-label text-orange-125">
    Test
  </div>
);

export default TestClientPill;
